<template>
    <v-container>
        <v-row>
            <v-col>
                Reports

                <v-radio-group @change="filter" mandatory>
                    <v-radio label="Siste dag"></v-radio>
                    <v-radio label="Siste 7 dager"></v-radio>
                    <v-radio label="Siste 31 dager"></v-radio>
                    <v-radio label="I år"></v-radio>
                    <v-radio label="Alle"></v-radio>
                </v-radio-group>

                <v-card>
                    <v-card-text>
                        <v-data-table :items="reports" :headers="headers" sort-desc :options="{ sortBy: ['createdAt'] }" @click:row="clickRow" class="table-cursor">
                            <template v-slot:[`item.createdAt`]="{ item }">
                                <div class="text-no-wrap">
                                    {{ moment.unix(item.createdAt).format("DD-MM-YYYY") }}
                                </div>
                            </template>
                            <template v-slot:[`item.application.ownedBy`]="{ item }">
                                <div class="text-no-wrap">
                                    {{ item.application.ownedBy.name }}
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as axios from "axios";
import * as moment from "moment";
export default {
    data() {
        return {
            date: moment().unix(),
            reports: [
                {
                    application: { name: "test" },
                },
            ],
            headers: [
                { text: "Bedrift", value: "application.ownedBy", sortable: false },
                { text: "Søknad", value: "application.name", sortable: false },
                { text: "Beløp (NOK)", value: "amount", sortable: false },
                { text: "Beskrivelse", value: "description", sortable: false },
                {
                    text: "dato",
                    value: "createdAt",
                    sortable: true,
                    filterable: true,
                    filter: (value, search, item) => {
                        return item.createdAt > this.date;
                    },
                },
            ],
            moment: moment,
        };
    },
    methods: {
        filter(dateNumber) {
            switch (dateNumber) {
                case 0:
                    // this.date = moment().startOf("day").unix();
                    this.date = moment().subtract(1, "day").unix();
                    break;
                case 1:
                    // this.date = moment().startOf("week").unix();
                    this.date = moment().subtract(7, "day").unix();
                    break;
                case 2:
                    // this.date = moment().startOf("month").unix();
                    this.date = moment().subtract(31, "day").unix();
                    break;
                case 3:
                    this.date = moment().startOf("year").unix();
                    // this.date = moment().subtract(1, "year").unix();
                    break;
                case 4:
                    this.date = 0;
                    break;
                default:
                    break;
            }
        },
        clickRow(x) {
            this.$router.push({ path: `/paymentadmin/${x.application.id}` });
        },
    },
    async mounted() {
        let reports = (await axios.get("/report/all")).data;
        this.reports = reports;
    },
};
</script>

<style>
.table-cursor tbody tr:hover {
    cursor: pointer;
}
</style>